<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { colors, operationTrendOption } from "./chart-options";

const toneColors = {
  article: colors.green,
  backlink: colors.orange,
  language: colors.purple,
};

export default {
  name: "OperationTrendChart",
  components: { ChartCanvas },
  props: {
    trend: { type: Array, default: () => [] },
    metricType: { type: String, default: "article" },
  },
  computed: {
    empty() {
      return !this.trend.some(
        (item) => item.monthly_count !== null || item.cumulative_count !== null
      );
    },
    option() {
      return operationTrendOption(
        this.trend,
        toneColors[this.metricType] || colors.green
      );
    },
  },
};
</script>
